import { useTranslation } from 'react-i18next'

export function useI18nTranslation(skip = false) {
  const { t, i18n } = useTranslation()
  const simplifiedTranslate = (key, props = {}) => t(key, { ...props })

  return { t: simplifiedTranslate, i18n }
}
